import { render } from "./ModalDetalhesSaldo.vue?vue&type=template&id=46ac689a"
import script from "./ModalDetalhesSaldo.vue?vue&type=script&lang=js"
export * from "./ModalDetalhesSaldo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__